import request from './request'

export const crm = {
  notificationConfig: () => request.get('/crm/notifications/config'),
  saveNotificationConfig: data => request.post('/crm/notifications/config',data),
  notificationRecords: () => request.get('/crm/notifications/records'),
  collectNotifications: () => request.post('/crm/notifications/collect'),
  testNotification: () => request.post('/crm/notifications/test'),
  retryNotification: id => request.post(`/crm/notifications/records/${id}/retry`),
  aiConfig: () => request.get('/crm/ai/config'),
  saveAiConfig: data => request.post('/crm/ai/config',data),
  aiStatus: () => request.get('/crm/ai/status'),
  aiChat: data => request.post('/crm/ai/chat',data,{timeout:100000}),
  confirmAiAction: token => request.post(`/crm/ai/actions/${token}/confirm`),
  cancelAiAction: token => request.post(`/crm/ai/actions/${token}/cancel`),
  customer360: id => request.get(`/crm/assistant/customers/${id}/360`),
  dealAssessment: id => request.get(`/crm/assistant/deals/${id}/assessment`),
  operatingSettings: () => request.get('/crm/operating-settings'),
  saveOperatingSettings: data => request.post('/crm/operating-settings',data),
  sendDailyDigest: () => request.post('/crm/operating-settings/digest'),
  analytics: () => request.get('/crm/analytics'),
  orders: () => request.get('/crm/orders'),
  orderDetail: id => request.get(`/crm/orders/${id}`),
  generateOrder: (id, quoteId) => request.post(`/crm/contracts/${id}/order`, { quoteId }),
  salesInvoices: () => request.get('/crm/sales-invoices'),
  salesInvoiceDetail: id => request.get(`/crm/sales-invoices/${id}`),
  saveSalesInvoice: data => request.post('/crm/sales-invoices', data),
  issueSalesInvoice: (id, version, invoiceNo) => request.post(`/crm/sales-invoices/${id}/issue`, { version, invoiceNo }),
  voidSalesInvoice: (id, version, reason) => request.post(`/crm/sales-invoices/${id}/void`, { version, reason }),
  billingTitle: id => request.get(`/crm/customers/${id}/billing-title`),
  saveBillingTitle: (id, data) => request.post(`/crm/customers/${id}/billing-title`, data),
  products: params => request.get('/crm/products', { params }),
  saveProduct: data => request.post('/crm/products', data),
  quoteDetail: id => request.get(`/crm/quotes/${id}`),
  submitQuote: (id, version) => request.post(`/crm/quotes/${id}/submit`, { version }),
  quoteRule: () => request.get('/crm/quotes/approval-rule'),
  saveQuoteRule: threshold => request.post('/crm/quotes/approval-rule', { threshold }),
  customValues: (type, id) => request.get(`/crm/custom-values/${type}/${id}`),
  saveCustomValues: (type, id, data) => request.post(`/crm/custom-values/${type}/${id}`, data),
  duplicates: (type, params) => request.get(`/crm/duplicates/${type}`, { params }),
  merge: (type, id, targetId) => request.post(`/crm/merge/${type}/${id}`, { targetId }),
  transferOwners: () => request.get('/crm/transfer/owners'),
  transfer: data => request.post('/crm/transfer', data),
  poolSettings: () => request.get('/crm/pool/settings'),
  savePoolSettings: data => request.post('/crm/pool/settings', data),
  recyclePool: () => request.post('/crm/pool/recycle'),
  detail: (type, id) => request.get(`/crm/details/${type}/${id}`),
  workbench: () => request.get('/crm/workbench'),
  leads: params => request.get('/crm/leads', { params }),
  saveLead: data => request.post('/crm/leads', data),
  releaseLead: id => request.post('/crm/leads/' + id + '/release'),
  claimLead: id => request.post('/crm/leads/' + id + '/claim'),
  convertLead: id => request.post('/crm/leads/' + id + '/convert'),
  customers: params => request.get('/crm/customers', { params }),
  saveCustomer: data => request.post('/crm/customers', data),
  releaseCustomer: id => request.post('/crm/customers/' + id + '/release'),
  claimCustomer: id => request.post('/crm/customers/' + id + '/claim'),
  contacts: params => request.get('/crm/contacts', { params }),
  saveContact: data => request.post('/crm/contacts', data),
  deals: params => request.get('/crm/deals', { params }),
  saveDeal: data => request.post('/crm/deals', data),
  quotes: () => request.get('/crm/quotes'),
  saveQuote: data => request.post('/crm/quotes', data),
  contracts: () => request.get('/crm/contracts'),
  saveContract: data => request.post('/crm/contracts', data),
  payments: params => request.get('/crm/payments', { params }),
  savePayment: data => request.post('/crm/payments', data),
  approvals: params => request.get('/crm/approvals', { params }),
  saveApproval: data => request.post('/crm/approvals', data),
  decideApproval: (id, data) => request.post('/crm/approvals/' + id + '/decide', data),
  activities: params => request.get('/crm/activities', { params }),
  saveActivity: data => request.post('/crm/activities', data),
  tasks: params => request.get('/crm/tasks', { params }),
  saveTask: data => request.post('/crm/tasks', data),
  fields: params => request.get('/crm/fields', { params }),
  saveField: data => request.post('/crm/fields', data)
}
